import Faster, { FasterConfiguration } from 'faster-sdk-js'
import events from './events'
import config from '../config'

const { applicationKey, applicationSecret, appVersion } = config
const configuration = new FasterConfiguration(applicationKey, applicationSecret, { appVersion })

Faster.configure(configuration)
class FasterWrapper {
  constructor() {
    this.faster = null
  }

  start() {
    this.faster = Faster.start()
    this.events = events
  }

  get deviceInfo() {
    if (this.faster == null) {
      return
    }

    return this.faster.analytics.device.get()
  }

  emit(id, parameters) {
    if (this.faster == null) {
      return
    }

    const event = this.events[id].build(parameters)
    this.faster.analytics.event.register(event)
  }
}

export default new FasterWrapper()
